
taxes.classy.controller({
    name: 'TaxSettingsController',
    inject: ['$scope', '$http', 'authServiceFactory', 'ApplicationService', '$q', '$modal', 
        'FamilyModelService', 'FamilyTaxModelService', 'FamilyTaxFamilyService'],

    init: function()
    {
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.ApplicationService = this.ApplicationService;

        this.family = this.FamilyModelService.get(0);
        this.$.taxinfo = this.ApplicationService.getFamilyData().familyTax[0];
        this.$.cYear = this.ApplicationService.getAwardData().app[0].App_Fin_Year;

        this.$.separate(this.family[0].taxDocuments);
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
    },
    clickVerification: function(type, priority) {
        if (typeof priority == 'undefined') priority = false;
        var parent = this;
        var modal = this.$modal.open({
            templateUrl: "fast/submodules/schoolside/applications/submodules/applicationOverview/submodules/taxes/partials/verificationModals/"+type+".html",
            controller: 'VerificationModalController',
            resolve: {
                priority: function() {
                    return priority;
                }
            }
        });
        modal.result.then(function(res) {
            parent.FamilyModelService.resolveData(parent.$.familyNo).then(function() {
                parent.family = parent.FamilyModelService.get();
                parent.$.separate(parent.family[0].taxDocuments);
            });
        });
    },
    separate: function(doc)
    {
        this.$.documentarray = [];
        let sNumber = doc.toString();

        for (var i=0, len=sNumber.length; i < len; i += 1) {
            this.$.documentarray.push(+sNumber.charAt(i));
        }
    },
    RetroModal: function(val)
    {
        if (val == 1) {
            this.flag = true;
        }
    },
    combine: function(doc)
    {
        var oldNumber = '';
        for (let key in doc) {
            oldNumber += doc[key].toString();
        }
        return oldNumber;
    },
    docPopup: function(index)
    {
        var parent = this;
        if (index == 1 && this.$.documentarray[index] == 0) {
            var message = "State Tax Forms are used to verify state taxes paid after non-refundable credits are deducted (if applicable). Failure to request this document will prevent verification of state taxes (where state taxes are applicable)."
        }
        else if (index == 2 && this.$.documentarray[index] == 0) {
            var message = "W-2s are used to verify income stated on Line 7 of 1040. Failure to request this document will prevent income verification."
        }
        else if (index == 3 && this.$.documentarray[index] == 0) {
            var message = "Schedule As are used to verify property tax. Failure to request this document will prevent tax verification."
        }
        if (this.$.documentarray[index] == 0) {
            swal({
                    title: "Warning!!",
                    text: message,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD68BB",
                    cancelButtonText: "Do not proceed",
                    confirmButtonText: "Proceed",
                    closeOnConfirm: true
                },
                function(isConfirm) {
                    if (!isConfirm) {
                        parent.$.documentarray[index] = 1;
                        parent.combine(parent.$.documentarray)
                    }
                });
        }
        this.$.documentarray = this.$.documentarray;
    }/*,
    submit: function(scope, instance, form)
    {
        var parent = this;
        instance.options.factor  = .3;
        if (this.$.taxinfo.currentYearAsk==0) {
            this.$.taxinfo.currentYearVer=0;
        }
        if (this.$.taxinfo.previousYearAsk==0) {
            this.$.taxinfo.previousYearVer=0;
        }

        if (this.flag==true) {
            this.clickVerification('reverify', false);
        }

        return this.$q.all([
            this.FamilyTaxFamilyService.putLog(this.$.taxinfo),
            this.FamilyTaxFamilyService.putHelper(this.$.taxinfo, {taxDocuments: this.combine(this.$.documentarray), familyID: this.ApplicationService.getFamilyData().data[0].familyID}, instance)
        ]).then(function(results) {
            var message = "";
            if (results[0].status !== 200) {
                message += "Log not insered"
            }
            console.log(results);
            console.log(instance);
        });
    },
    successSave: function(scope, instance, callback)
    {
        console.log("hey!");
        var parent = this;
        this.$http.get("/api/family/"+this.ApplicationService.getFamilyData().data[0].familyID+"/taxLog").then(function(results) {
            parent.ApplicationService.getFamilyData().taxLog = results.data;
        });
        this.SliderService.closeSlider(0);
        if (typeof callback !== 'undefined')
            callback();
    }*/
    
});


taxes.classy.controller({
    name: 'VerificationModalController',
    inject: ['$scope', '$http', '$sce', 'authServiceFactory', '$modalInstance', 'DateService',
        'ApplicationService', 'FamilyTaxModelService', 'FamilyModelService', 'priority'],
    init: function()
    {
        this.$.$sce = this.$sce;
        this.$.$modalInstance = this.$modalInstance;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.priority = this.priority;
        this.$.priority_verify = 0;
        this.$.priority_reverify = 0;
    },
    priorityVerify: function() {
        var parent = this;
        if (this.$.verify_agree && this.$.priority_agree) {
            //priority verify here
            return this.$http.put("/api/familyTax/"+ this.ApplicationService.getFamilyData().data[0].familyID +"/priorityVerify",
                {"priority": true})
            .then(function() {
                parent.$.$modalInstance.close();
            });
        }
    },
    verificationNotRequired: function() {
        var parent = this;
        if (this.$.verify_agree) {
            //Set to verification not required
            return this.$http.put("/api/familyTax/"+ this.ApplicationService.getFamilyData().data[0].familyID +"/verificationNotRequired").then(function() {
                parent.$.$modalInstance.close();
            });
        }
    },
    verifyAsIs: function() {
        if (this.$.verify_agree && (this.$.priority_agree || !this.$.priority_verify)) {
            // set to Verify as is here
            let famData = this.ApplicationService.getFamilyData();
            let famID = famData.data[0].familyID;
            let apipath = {
                verifyAsIs: "/api/familyTax/" + famID + "/verifyAsIs",
                taxLog: "/api/family/" + famID+ "/taxLog"
            };
            return this.$http.put(apipath.verifyAsIs, {priority: this.$.priority_verify}).then(() => {
                this.$http.get(apipath.taxLog).then((results) => {
                    famData.taxFileLog[famID].push(results.data);
                    this.$.$modalInstance.close();
                });
            });
        }
    },
    reVerify: function() {
        var parent = this;
        if (this.$.verify_agree && this.$.reverReason.length>0 && (this.$.priority_agree || !this.$.priority_reverify) ) {
            //Reverify here
            return this.$http.put("/api/familyTax/"+ this.ApplicationService.getFamilyData().data[0].familyID +"/reVerify",
                {"priority": this.$.priority_reverify, "reason": this.$.reverReason })
            .then(function() {
                parent.$.$modalInstance.close();
            });
        }
    }
    
});